import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { PlatformEnum } from "app/services/enum/platform.enum";

export class CheckingAccountLimitCommand extends IRequestCommand<
ICheckingAccountLimitResponse,
  ErrorDetails,
  IICheckingAccountLimitParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/travels/passenger/{passengerId}/checkExceedingLimit/{paymentMethod}/{platform}';
  override _needAuthenticate = true;

  public override setParameters(parameters: IICheckingAccountLimitParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId
    );
    this._commandUrl = this._commandUrl.replace(
        '{passengerId}',
        parameters.requesterUserId
      );
    this._commandUrl = this._commandUrl.replace(
    '{paymentMethod}',
    parameters.paymentMethod
    );
    this._commandUrl = this._commandUrl.replace(
        '{platform}',
        PlatformEnum.Web
        );
    this._commandBody = parameters;
  }
}

export interface IICheckingAccountLimitParameters
  extends ICommandParameters {
  carrierUserId?: string;
  requesterUserId: string;
  paymentMethod: string;
}

export interface ICheckingAccountLimitResponse extends ICommandResponse {}